var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14062 12.106H27.8766",
    stroke: "url(#paint0_linear_1044_4069)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5659 1V5.9365",
    stroke: "url(#paint1_linear_1044_4069)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44922 1V5.9365",
    stroke: "url(#paint2_linear_1044_4069)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8574 3.36879H8.15645C3.75141 3.36879 1 5.82269 1 10.3333V23.9078C1 28.4894 3.75141 31 8.15645 31H20.8435C25.2624 31 28 28.5319 28 24.0213V10.3333C28.0138 5.82269 25.2763 3.36879 20.8574 3.36879Z",
    stroke: "url(#paint3_linear_1044_4069)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1913 22.1875C9.49947 22.1875 8.87088 21.9133 8.30557 21.3648C7.75713 20.7995 7.48291 20.1414 7.48291 19.3905C7.48291 18.6058 7.77822 17.9308 8.36885 17.3655C8.95947 16.7833 9.65135 16.4922 10.4445 16.4922C11.2798 16.4922 11.9843 16.7791 12.5581 17.3528C13.1318 17.9266 13.4187 18.6058 13.4187 19.3905C13.4187 20.0908 13.136 20.8881 12.5707 21.7825L10.0521 25.5541L9.11557 24.9086L11.2545 21.947L11.2292 21.9217C10.9592 22.0989 10.6132 22.1875 10.1913 22.1875ZM12.2417 19.3778C12.2417 18.8884 12.0645 18.4708 11.7101 18.1248C11.3642 17.7789 10.9423 17.6059 10.4445 17.6059C9.94666 17.6059 9.52479 17.7789 9.17885 18.1248C8.83291 18.4708 8.65994 18.8884 8.65994 19.3778C8.65994 19.8672 8.83291 20.2848 9.17885 20.6308C9.54166 20.9767 9.96354 21.1497 10.4445 21.1497C10.9254 21.1497 11.3473 20.9767 11.7101 20.6308C12.0645 20.2933 12.2417 19.8756 12.2417 19.3778Z",
    fill: "url(#paint4_linear_1044_4069)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4796 21.0231C14.4796 19.7069 14.8045 18.6227 15.4542 17.7705C16.1039 16.9183 16.9392 16.4922 17.9601 16.4922C18.981 16.4922 19.8164 16.9225 20.466 17.7831C21.1157 18.6353 21.4406 19.7153 21.4406 21.0231C21.4406 22.3225 21.1157 23.4067 20.466 24.2758C19.8164 25.128 18.981 25.5541 17.9601 25.5541C16.9392 25.5541 16.1039 25.128 15.4542 24.2758C14.8045 23.4067 14.4796 22.3225 14.4796 21.0231ZM20.2509 21.0231C20.2509 20.0275 20.04 19.2091 19.6181 18.5678C19.2046 17.9266 18.652 17.6059 17.9601 17.6059C17.2682 17.6059 16.7156 17.9266 16.3021 18.5678C15.8803 19.2091 15.6693 20.0275 15.6693 21.0231C15.6693 22.0188 15.8803 22.8414 16.3021 23.4911C16.7156 24.1239 17.2682 24.4403 17.9601 24.4403C18.652 24.4403 19.2046 24.1197 19.6181 23.4784C20.04 22.8288 20.2509 22.0103 20.2509 21.0231Z",
    fill: "url(#paint5_linear_1044_4069)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1044_4069",
    x1: 14.5086,
    y1: 12.106,
    x2: 14.5086,
    y2: 13.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1044_4069",
    x1: 21.0659,
    y1: 1,
    x2: 21.0659,
    y2: 5.9365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1044_4069",
    x1: 8.94922,
    y1: 1,
    x2: 8.94922,
    y2: 5.9365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1044_4069",
    x1: 14.5,
    y1: 3.36879,
    x2: 14.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1044_4069",
    x1: 14.4617,
    y1: 16.4922,
    x2: 14.4617,
    y2: 25.5541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1044_4069",
    x1: 14.4617,
    y1: 16.4922,
    x2: 14.4617,
    y2: 25.5541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5CDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterest);
export default __webpack_public_path__ + "static/media/interest.40348a55c97abfb80764c12492ee587b.svg";
export { ForwardRef as ReactComponent };